import clsx from 'clsx';

import RichText from '../RichText';
import styles from './Timeline.module.scss';

const Line = ({ year, text }) => {
  return (
    <li className={styles.li}>
      <div className={styles.line}>
        <div className={styles.marker}>
          <div className={clsx(styles.blob)}></div>
          <div className={styles.connector}></div>
        </div>
        <span className={styles.year}>{year}</span>
        <div className={styles.text}>
          <RichText
            content={text}
            align="left"
            isSectionCentered={false}
            largeParagraphText={false}
          />
        </div>
      </div>
    </li>
  );
};

export default Line;
